import React, { useState, useEffect } from 'react';
import { TransformationMaturity } from '../../types';

interface TransformationNotesModalProps {
  transformation: TransformationMaturity;
  onClose: () => void;
  onSave: (notes: string) => void;
}

const TransformationNotesModal: React.FC<TransformationNotesModalProps> = ({
  transformation,
  onClose,
  onSave
}) => {
  const [notes, setNotes] = useState(transformation.notes || '');
  const maxLength = 2000;

    useEffect(() => {

        const handleEsc = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };

        window.addEventListener('keydown', handleEsc);
        return () => window.removeEventListener('keydown', handleEsc);
    });

  // Handle click outside to close modal
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (target.classList.contains('modal-overlay')) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  // Handle ESC key to close modal
  useEffect(() => {
    const handleEscKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscKey);
    return () => {
      document.removeEventListener('keydown', handleEscKey);
    };
  }, [onClose]);

  const handleNotesChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;
    if (value.length <= maxLength) {
      setNotes(value);
    }
  };

  const handleSave = () => {
    onSave(notes);
  };

  return (
    <div className="fixed inset-0 flex justify-end items-start z-50 modal-overlay bg-black bg-opacity-30">
      <div className="bg-white h-full w-full max-w-md shadow-lg flex flex-col animate-slide-in-right">
        <div className="flex justify-between items-center p-4 border-b">
          <h2 className="text-xl font-bold italic text-[#002B5C]">{transformation.transformationArea}</h2>
          <button 
            onClick={onClose}
            className="rounded-full p-1 hover:bg-gray-200 focus:outline-none"
          >
            <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>
        
        <div className="p-4 flex-grow flex flex-col">
          <label className="block text-gray-600 mb-2">Notes</label>
          <textarea
            value={notes}
            onChange={handleNotesChange}
                      className="w-full h-40 p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-[#0F2A4F] resize-none"
            placeholder="Add notes here..."
            autoFocus
          />
          <div className="text-gray-400 text-sm mt-2 text-right">
            {notes.length}/{maxLength} chars remaining
          </div>
        </div>
        
        <div className="p-4 border-t flex justify-end">
          <button
            onClick={handleSave}
                      className="px-4 py-2  text-white bg-[#0F2A4F] rounded-md hover:bg-blue-900 focus:outline-none"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default TransformationNotesModal;